import { Injectable, EventEmitter }    from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { WsseService } from '../security/wsse.service';

@Injectable()
export class UploadService {
  public progress: any;
  public progressObserver: any;

  constructor (private wsseService: WsseService) {
    this.progress = Observable.create(observer => {
        this.progressObserver = observer
    }).share();
  }

  public makeFileRequest (url: string, files: File[]): Observable<any> {
    return Observable.create(observer => {
        let formData: FormData = new FormData(),
            xhr: XMLHttpRequest = new XMLHttpRequest();

        for (let i = 0; i < files.length; i++) {
            formData.append("uploads[]", files[i], files[i].name);
        }

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    observer.next(JSON.parse(xhr.response));
                    observer.complete();
                } else {
                    observer.error(xhr.response);
                }
            }
        };

        xhr.upload.onprogress = (event) => {
            this.progress = Math.round(event.loaded / event.total * 100);

            // this.progressObserver.next(this.progress);
        };

        xhr.open('POST', url, true);
        
        let token: string = this.wsseService.getHeader();
        if(token){
            xhr.setRequestHeader('X-WSSE', token);
        }

        xhr.send(formData);
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/upload.service.ts